import React, { useEffect, useState } from "react";
import "../Components/ComponentCss/CheckOutChip.css"; // 스타일 import

const CheckOutChip = ({ label, id, state, onCheckChange }) => {
    const [checked, setChecked] = useState(state);

    // 상태가 변경될 때마다 체크박스 상태 업데이트
    useEffect(() => {
        setChecked(state);
    }, [state]);

    // 체크박스 상태 변경 처리
    const handleChange = () => {
        setChecked(!checked);
        onCheckChange(id, !checked); // 부모 컴포넌트로 상태 변경 전달
    };

    return (
        <div className="checkbox-wrapper">
            <input
                id={id}
                name="checkbox"
                type="checkbox"
                checked={checked}
                onChange={handleChange} // 체크박스 상태 변경 시 호출
                style={{ display: "none" }}
            />
            <label className="terms-label" htmlFor={id}>
                <SVGIcon checked={checked} />
                <span className="label-text">{label}</span>
            </label>
        </div>
    );
};

// SVG 아이콘 (체크박스 스타일)
const SVGIcon = ({ checked }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 200 200"
            className="checkbox-svg"
        >
            <mask fill="white" id="path-1-inside-1">
                <rect height="200" width="200"></rect>
            </mask>
            <rect
                mask="url(#path-1-inside-1)"
                strokeWidth="40"
                className="checkbox-box"
                height="200"
                width="200"
                style={{
                    strokeDashoffset: checked ? "0" : "800", // 애니메이션
                }}
            ></rect>
            <path
                strokeWidth="15"
                d="M52 111.018L76.9867 136L149 64"
                className="checkbox-tick"
                style={{
                    strokeDashoffset: checked ? "0" : "172", // 애니메이션
                }}
            ></path>
        </svg>
    );
};

export default CheckOutChip;
